export default __webpack_public_path__ + "static/feature-importances-sales-424f09c5f49b704be106cae24d7d8d3e.webp";